const normalizeSortOrder = (sortOrder) => {
  const value = Number(sortOrder)
  return sortOrder != null && Number.isFinite(value)
    ? value
    : Number.MAX_SAFE_INTEGER
}

// Sorts by the given order attribute (items without one go last) and then by id
export const compareByOrderAttribute = (attribute) => (first, second) =>
  normalizeSortOrder(first[attribute]) -
    normalizeSortOrder(second[attribute]) || first.id - second.id

const compareBySortOrder = compareByOrderAttribute('sortOrder')

export default compareBySortOrder
